import React, { useContext } from "react";
import { UserContext } from "../../Context/UserContext";

/**
 * RoleValidator Component
 *
 * Conditionally renders or disables its children based on the user's role.
 *
 * @param {string} userRole - Current user's role
 * @param {string|string[]} allowedRoles - Role(s) allowed to view or enable content
 * @param {React.ReactNode} children - Automatically passed child components
 * @param {React.ReactNode} [fallback=null] - Content shown if access is denied
 * @param {"hide"|"disable"} [mode="hide"] - "hide" removes element, "disable" shows but disables
 *
 * @returns {React.ReactNode} Rendered children or fallback content
 */
const RoleValidator = ({
  allowedRoles,
  children,
  fallback = null,
  mode = "disable"
}) => {
  const { user } = useContext(UserContext);
  const allowed = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
  const hasAccess = allowed.includes(user.role);

  if (mode === "disable" && React.isValidElement(children)) {
    const extraProps = !hasAccess
      ? {
          disabled: true,
          className: `${children.props.className || ""} opacity-50 cursor-not-allowed`
        }
      : {};

    return React.cloneElement(children, extraProps);
  }

  return hasAccess ? children : fallback;
};

export default RoleValidator;
